import { AttivitaRequest } from './../models/attivita.model';
import { AxiosInstance } from 'axios';
import { BaseService, Page } from 'yellowfin-ui-lib';
import { Attivita } from '../models/attivita.model';
import { classToPlain } from 'class-transformer';

export class AttivitaService extends BaseService {

    constructor(http: AxiosInstance) {
        super(http);
    }

    getAttivitaByRange(start: number, from: number): Promise<Attivita[]> {
        return this.mapResponse(this.http.get(`web/attivita/search/${start}/${from}`), Attivita);
    }

    getAttivitaLatest(howmany: number): Promise<Attivita[]> {
        return this.mapResponse(this.http.get(`web/attivita/last/${howmany}`), Attivita);
    }



    search(request: AttivitaRequest, page: Page): Promise<Attivita[]> {
        //return this.mapResponse(this.http.get(`web/attivita/search/${request.start}/${request.stop}`), Attivita);
        return this.mapResponse(this.http.post(`web/attivita/advsearch/range/${page.start}/${page.stop}`, classToPlain(request)), Attivita);
    }

    searchCount(request: AttivitaRequest): Promise<any> {
        return this.mapResponse(this.http.post(`web/attivita/advsearch/count`, classToPlain(request)), Attivita);
    }


}